import { ExpandLess, ExpandMore } from "@mui/icons-material"
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardHeaderProps,
  Collapse,
  Divider,
  IconButton,
} from "@mui/material"

import React from "react"
import { colors } from "styles/colors"

type CollapsibleCardProps = {
  open: boolean
  children: React.ReactNode
  onToggle?: () => void
  cardActions?: React.ReactNode
} & CardHeaderProps

export const CollapsibleCard = (props: CollapsibleCardProps) => {
  const { open, children, onToggle, cardActions, ...rest } = props

  const handleToggle = () => {
    onToggle?.()
  }

  return (
    <Card>
      <CardHeader
        sx={{ padding: "1rem 1rem 0.5rem 1rem" }}
        slotProps={{ title: { variant: "h3" } }}
        {...rest}
        onClick={handleToggle}
        action={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {props.action && open ? props.action : null}
            {onToggle && (
              <IconButton aria-label="Toggle">{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
            )}
          </Box>
        }
      />
      <Box sx={{ px: 2 }}>
        <Divider
          sx={{
            marginBottom: 2,
            borderColor: colors.border.top.default,
          }}
        />
      </Box>
      <Collapse in={open}>
        <CardContent sx={{ py: 0, flex: 1 }}>{children}</CardContent>
        {cardActions && <CardActions sx={{ py: 0 }}>{cardActions}</CardActions>}
      </Collapse>
    </Card>
  )
}
